export default __webpack_public_path__ + "static/media/i141hp.b7c493a2.webp";